<template>
  <div class="person-management">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="page-content">
      <div style="flex: 1;">
        <div class="search-line">
          <div class="btn-box">
            <button-add :value="addBtnValue" :pathName="addPersonRouterName" v-if="permissionCodes.indexOf('001005001') !== -1" />
            <button-delete @deleteSelection="deleteSelection" v-if="permissionCodes.indexOf('001005002') !== -1"/>
<!--            <button-confirm-next value="人员审批" @confirm="showWindowLeftBox" />-->
            <button-cancel value="人脸验证" @cancel="showUpdateRecord" />
            <button-upload :cathUrl="uploadUrl" v-if="permissionCodes.indexOf('001005004') !== -1" :onSuccess="uploadSuccess" @getpage="getPage" value="导入"/>
            <button-export :href="exportUrl" :beforeDownload="beforeDownload" v-if="permissionCodes.indexOf('001005005') !== -1" download="download.xls" value="导出"/>
          </div>
          <input-search placeholder="姓名/手机号/房间号/实体卡号" @search="search" style="width: 280px;"/>
        </div>

        <div class="search-line">
          <div style="display: flex;justify-content: flex-start">
            <input-select selectTitle="人员类型" :selectKey="'personType'" selectWidth="140px" :selectData="personTypeList" @search="searchCardType" style="margin-right: 10px;"/>
            <input-select selectTitle="微信授权" :selectKey="'isAuthorize'" selectWidth="106px" :selectData="isAuthorizeList" @search="searchIsAuthorize" style="margin-right: 10px;"/>
            <input-select selectTitle="微信公众号" :selectKey="'isSubscribe'" selectWidth="106px" :selectData="isSubscribeList" @search="searchIsSubscribe"/>
            <input-select selectTitle="入住状态" :selectKey="'stayStatus'" selectWidth="106px" :selectData="stayStatusList" @search="searchStayStatus"/>
          </div>
          <input-select selectTitle="人员照片" :selectKey="'hasPhoto'" :selectData="hasPhotoList" @search="searchHasPhoto"/>
        </div>

        <table-main
          :tableHead="tableHead"
          :tableData="tableData"
          @deleteLine="deleteLine"
          @toCurrentPage="toCurrentPage"
          @changeSelection="changeSelection"
          @checkIn="checkIn"
          :total="total"
          :pageNum="pageNum"
          :pageSize="pageSize"
          :operationArr="operationArr"
          tableOperationWidth="220px"
          :tableHeight="619"
          @changePagination="changePagination" />
      </div>
    </div>

    <div>
      <transition name="right-slide">
        <div class="window-left-box" v-show="windowLeftBox">
          <div class="window-left-main">

            <div class="search-line" style="margin: 10px 0">
              <div class="btn-box">

              </div>
              <input-search placeholder="姓名/手机号" @search="windowLeftSearch"/>
            </div>
            <div>
              <table-main
                :selection="false"
                :tableHead="windowLeftTableHead"
                :tableData="windowLeftTableData"
                :total="windowLeftTotal"
                :pageNum="windowLeftPageNum"
                :pageSize="windowLeftPageSize"
                :hasOperation="false"
                @changePagination="changeWindowLeftPagination"
                :row-click="windowLeftRowClick" />
            </div>
          </div>
          <div class="mask" @click.capture.stop="windowLeftBox = !windowLeftBox"></div>
        </div>
      </transition>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="驳回申请" :visible.sync="approveDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">驳回原因</div>
            <el-input type="textarea" :rows="4" placeholder="请输入驳回原因" v-model="unApproveReason" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="approveDialog = false">取 消</el-button>
          <el-button size="small" type="primary" @click="rejectApprove">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <el-dialog title="人脸验证" :visible.sync="dialogVisible" width="80%" style="height:100%" :before-close="handleClose">
      <div class="search-line">
<!--        <div class="btn-box">-->
<!--          <button-export-->
<!--            :href="exportUrl"-->
<!--            :beforeDownload="beforeDownload"-->
<!--            download="download.xls"-->
<!--            value="导出"/>-->
<!--        </div>-->
        <input-select
          v-if="dialogVisible"
          selectTitle="比对状态"
          :selectKey="'faceVerifySuccessly'"
          :selectData="answeredTypeList"
          @search="search2"/>
        <input-search v-if="dialogVisible" placeholder="姓名/手机号"  @search="searchKey2" />
      </div>
      <table-main
        :selection="false"
        :tableHeight="500"
        :tableHead="tableHead2"
        :tableData="tableData2"
        :total="total2"
        :pageNum="requestData2.pageNum"
        :pageSize="requestData2.pageSize"
        :hasOperation="false"
        @changePagination="changePagination2" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm2" size="small">确 认</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import TheTree from '../../../components/Tree/the-tree'
import STree from '../../../components/common/s-tree'
import {treeApi} from '../../api/TreeApi'
import {api} from '../../api/Person'
import {errorHandler} from '../../../utils/errorHandler'
import {nAlert, nSuccess, nWarn} from '../../../utils/notice'
import {bus} from '../../../utils/bus'
import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from "../../../components/Button/ButtonCancel";

export default {
  components: {
    ButtonConfirm,
    ButtonConfirmNext,
    STree,
    TheTree,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    ButtonCancel,
    Breadcrumb},
  name: 'person-management',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '资源中心',
        name: 'yq-information'
      }, {
        value: '人员管理'
      }],
      filterText: '',
      treeUpdate: {
        render: (code, searchKey) => {
          return treeApi.getChildrenByCode(code || 0, searchKey)
            .then(list => {
              let showList = []
              if (bus.global.yqCode === 'dhwl' && bus.global.accountName === 'xiaobao') {
                list.forEach(tree => {
                  tree._label = tree.enterpriseName
                  if (tree.enterpriseName === '电魂大厦B座' || tree.enterpriseName === '校宝在线（杭州）科技股份有限公司') {
                    showList.push(tree)
                  }
                })
              } else {
                list.forEach(tree => {
                  tree._label = tree.enterpriseName
                  showList.push(tree)
                })
              }
              return showList
            })
        }
      },
      addBtnValue: '新增人员',
      addPersonRouterName: 'person-add',
      exportUrl: '',
      uploadUrl: '',
      personTypeList: [
        {key: '', label: '全部'},
        {key: 1, label: '入住人'},
        {key: 2, label: '签约人'},
        {key: 3, label: '工作人员'},
        {key: 4, label: '管理员'},
        {key: 0, label: '游客'},
      ],
      isAuthorizeList: [
        {key: '', label: '全部'},
        {key: '0', label: '未授权'},
        {key: '1', label: '已授权'}
      ],
      isSubscribeList: [
        {key: '', label: '全部'},
        {key: '0', label: '未绑定'},
        {key: '1', label: '已绑定'}
      ],
      stayStatusList: [
        {key: '', label: '全部'},
        {key: '0', label: '未入住'},
        {key: '1', label: '已入住'}
      ],
      hasPhotoList: [
        {key: '', label: '全部'},
        {key: '0', label: '无照片'},
        {key: '1', label: '有照片'}
      ],
      tableHead: [
        {prop: 'name', label: '姓名'},
        {prop: 'phone', label: '手机号'},
        {prop: 'personTypeText', label: '人员类型'},
        {prop: 'leaseNameOnPage', label: '承租主体'},
        {prop: 'stayStatusText', label: '入住状态'},
        {prop: 'leaseRoomLabel', label: '房间号'},
        {prop: 'wxReceiveCardState', label: '微信授权状态'},
        {prop: 'isSubscribeText', label: '微信公众号'},
        {prop: 'cardNumberEntity', label: '实体卡号'},
        {prop: 'yqPicUrl', label: '人员照片', isPic: true},
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      searchKey: '',
      personType: '',
      hasPhoto: '',
      isAuthorize: '',
      isSubscribe: '',
      stayStatus: '',
      selectionArr: [],
      windowLeftBox: false,
      windowLeftTableHead: [
        {
        prop: 'name',
        label: '姓名'
      }, {
        prop: 'phone',
        label: '手机号'
      }, {
        prop: 'personTypeName',
        label: '人员类型'
      }, {
        prop: 'yqPicUrl',
        label: '人员照片',
        isPic: true
      }],
      windowLeftTableData: [],
      windowLeftSearchKey: '',
      windowLeftTotal: 0,
      windowLeftPageNum: 1,
      windowLeftPageSize: 10,
      drawer: false,
      drawerPersonData: {},
      enterpriseLoading: false,
      enterpriseList: [],
      approveDialog: false,
      unApproveReason: '',
      yqAppCode: '',
      accountName: '',
      requestData2:{
        searchKey: "",
        pageSize: 10,
        pageNum: 1,
      },
      tableHead2:[
        {prop: 'name', label: '姓名'},
        {prop: 'sexText', label: '性别'},
        {prop: 'phone', label: '手机号'},
        {prop: 'identityNumber', label: '身份证号'},
        {prop: 'yqPicUrl', label: '图片', isPic:true},
        {prop: 'faceVerifySuccesslyText', label: '比对状态'},
        {prop: 'faceVerifyMes', label: '比对信息'},
        {prop: 'createTime', label: '创建时间'}
      ],
      total2:0,
      dialogVisible:false,
      tableData2:[],
      answeredTypeList:[
        {key:"", label:"全部",},
        {key:"1", label:"比对成功"},
        {key:"2", label:"比对失败"}
      ],
      operationArr: ['checkIn', 'cardDelete', 'current'],
    }
  },
  created () {
    this.yqAppCode = bus.global.yqCode
    this.accountName = bus.global.accountName
    this.permissionCodes = bus.global.permissionCodes
    this.uploadUrl = api.importPerson
    if (this.yqAppCode === 'testgy') {
      this.personTypeList = [
        {key: '', label: '全部'},
        {key: 1, label: '入住人'},
        {key: 2, label: '签约人'},
        {key: 3, label: '工作人员'},
        {key: 4, label: '管理员'},
        {key: 0, label: '游客'},
        {key: 5, label: '家属人员'},
      ];
    } else {
      this.personTypeList = [
        {key: '', label: '全部'},
        {key: 1, label: '入住人'},
        {key: 2, label: '签约人'},
        {key: 3, label: '工作人员'},
        {key: 4, label: '管理员'},
        {key: 0, label: '游客'},
      ]
    }
    this.getPage()
    // this.getPersonPicUpdateRecordPage()
  },
  activated() {
    this.getPage()
  },
  methods: {
    getPersonPicUpdateRecordPage(){
      this.$axios.post(api.getPersonPicUpdateRecordPage,this.requestData2).then(res=>{
        this.tableData2=res.data.data.list;
        this.tableData2.map(v=>{
          if(v.sex=='0'){
            v.sexText='男'
          }else{
            v.sexText='女'
          }
          if(v.faceVerifySuccessly=='1'){
            v.faceVerifySuccesslyText='比对成功'
          }else{
            v.faceVerifySuccesslyText='比对失败'
          }
          v.yqPicUrl=v.picUrl
          this.total2=res.data.data.total
        })
      }).catch(errorHandler("获取人脸验证记录"))
    },
    changePagination2(data) {
      this.requestData2.pageNum = data[0];
      this.requestData2.pageSize = data[1];
      // this.getQuestionList();
      this.getPersonPicUpdateRecordPage();
    },
    searchKey2(v) {
      this.requestData2.pageNum = 1;
      this.requestData2.searchKey = v;
      this.getPersonPicUpdateRecordPage();
    },
    search2(v) {
      this.requestData2.pageNum = 1;
      this.requestData2[v.key] = v.value;
      this.getPersonPicUpdateRecordPage();
    },
    confirm2() {
      this.dialogVisible = false;
    },
    beforeDownload () {
      this.exportUrl = `${api.exportPerson}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.searchKey}&personType=${this.personType}&hasPhoto=${this.hasPhoto}&isAuthorize=${this.isAuthorize}&isSubscribe=${this.isSubscribe}&stayStatus=${this.stayStatus}`
    },
    uploadSuccess (data) {
      const e = errorHandler('导入失败')(data)
      if (!(e instanceof Error)) {
        nSuccess('导入成功')
        this.getPage()
      }
    },
    getPage () {
      this.$axios.post(api.getPersonPage, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        searchKey: this.searchKey,
        hasPhoto: this.hasPhoto,
        isAuthorize: this.isAuthorize,
        isSubscribe: this.isSubscribe,
        stayStatus: this.stayStatus,
        personType: this.personType
      })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            data.map(v => {
              v.leaseRoomLabel = ''
              if (v.bedsCode) {
                v.leaseRoomLabel = `${v.buildingName}/${v.floorName}/${v.roomNumber}/${v.bedsNumber}`
              } else if (v.buildingName) {
                v.leaseRoomLabel = `${v.buildingName}/${v.floorName}/${v.roomNumber}`
              }
              this.personTypeList.map(type => {
                if (type.key === v.personType && v.personType !== '') {
                  v.personTypeText = type.label
                }
              })
              let lease = v.lease || {}
              v.leaseNameOnPage = ''
              if (lease.mainType === 0) {
                v.leaseNameOnPage = lease.personName
              } else if (lease.mainType === 1) {
                v.leaseNameOnPage = lease.enterpriseName
              }
              v.wxReceiveCardState = v.wxOpenId ? '已授权' : '未授权'
              v.isSubscribeText = v.isSubscribe === '1' ? '已绑定' : '未绑定'
              v.stayStatusText = v.stayStatus === 1 ? '已入住' : '未入住'
            })
            this.total = res.data.data.total
            this.tableData = data
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
    searchCardType (v) {
      this.pageNum = 1
      this.personType = v.value
      this.getPage()
    },
    searchIsAuthorize (v) {
      this.pageNum = 1
      this.isAuthorize = v.value
      this.getPage()
    },
    searchIsSubscribe (v) {
      this.pageNum = 1
      this.isSubscribe = v.value
      this.getPage()
    },
    searchStayStatus(v) {
      this.pageNum = 1
      this.stayStatus = v.value
      this.getPage()
    },
    searchHasPhoto (v) {
      this.pageNum = 1
      this.hasPhoto = v.value
      this.getPage()
    },
    search (v) {
      this.pageNum = 1
      this.searchKey = v
      this.getPage()
    },
    windowLeftSearch (v) {
      this.windowLeftPageNum = 1
      this.windowLeftSearchKey = v
      this.getBaklogPage()
    },
    changePagination (data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    toCurrentPage (code) {
      console.log(code, 'person_current')
      this.$router.push({
        path: `/person_current/${code}`
      })
    },

    // 人员入住
    checkIn (data) {
      console.log(data.roomCode, 'roomcode')
      /*if (!data.roomCode || data.roomCode === '--') {
        nWarn('请在承租信息中绑定房间');
        return;
      }*/
      if (data.stayStatus === 1) {
        nWarn('人员已入住,请勿重复办理');
        return;
      }
      this.tableData.map(item =>{
        if (item.code === data.code) {
          console.log(data.code, 'code')
          this.$router.push({
            name: `person-check-in`,
            params: {
              data: data
            }
          })
        }
      })
      return;
    },
    deleteSelection () {
      if (this.selectionArr.length === 0) {
        nAlert('请先选择需要删除的人员')
        return false
      } else {
        this.$confirm('确定删除已选中的人员？', '提示')
          .then(() => {
            this.deleteLine(this.selectionArr)
          })
          .catch(() => {
            console.log('取消删除')
          })
      }
    },
    deleteLine (code) {
      this.$axios.post(api.deletePersonByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.selectionArr = []
            this.getPage()
          }
        })
        .catch(errorHandler('删除人员信息失败'))
    },

    changeWindowLeftPagination (data) {
      this.windowLeftPageNum = data[0]
      this.windowLeftPageSize = data[1]
      this.getBaklogPage()
    },

    //点击列表内容展示房间及合同信息
    housingRowClick (row, event, column) {
      this.windowLeftBox = true
      this.windowLeftInfo = row
      this.getContractByRoomCode()
    },

    // 展示人员申请
    showWindowLeftBox () {
      this.windowLeftBox = true
      this.enterpriseRemoteMethod()
      this.getBaklogPage()
    },

    // 返回
    personDataToWindowLeft () {
      this.drawer = false
      this.windowLeftBox = true
    },

    // 点击人员查看详情
    windowLeftRowClick (row, event, column) {
      this.windowLeftBox = false
      this.drawer = true
      this.getPersonBaklogByCode(row.baklogCode)
    },
    // 获取审批人员详情
    getPersonBaklogByCode (code) {
      this.$axios.get(`${api.getPersonBaklogByCode}/${code}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.drawerPersonData = data
          }
        })
        .catch(errorHandler('获取详情失败'))
    },

    handleClose(done) {
      done()
      // this.windowLeftBox = true
    },

    // 查询人员申请列表
    getBaklogPage () {
      this.$axios.post(api.getBaklogPage, {
        pageNum: this.windowLeftPageNum,
        pageSize: this.windowLeftPageSize,
        searchKey: this.windowLeftSearchKey
      })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            data.map(v => {
              v.yqPicUrl = v.personPicUrl
              if (v.personType === '1') {
                v.personTypeName = '员工'
              } else if (v.personType === '2') {
                v.personTypeName = '三方'
              } else if (v.personType === '3') {
                v.personTypeName = '企业管理员'
              } else if (v.personType == 5) {
                v.personTypeName = '家属人员'
              } else {
                v.personTypeName = ''
              }
            })
            this.windowLeftTotal = res.data.data.total
            this.windowLeftTableData = data
          }
        })
        .catch(errorHandler('获取申请列表失败'))
    },

    // 搜索企业列表
    enterpriseRemoteMethod (query) {
      this.enterpriseLoading = true;
      this.$axios.post(api.getEnterpriseList, {
        searchKey: query || ''
      })
        .then(res => {
          if (res.data.retCode === 1) {
            this.enterpriseLoading = false;
            let data = res.data.data
            this.enterpriseList = data
          }
        })
        .catch(errorHandler('获取公司列表失败'))
    },

    // 同意申请
    confirmApprove () {
      this.$axios.post(`${api.approveBaklogByCode}`, this.drawerPersonData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('审批通过')
            this.drawer = false
            this.windowLeftBox = true
            this.getBaklogPage()
          }
        })
        .catch(errorHandler('审批失败'))
    },

    // 驳回申请
    rejectApprove () {
      let drawerPersonData = this.drawerPersonData
      drawerPersonData.unApproveReason = this.unApproveReason
      this.$axios.post(`${api.unApproveBaklogByCode}`, drawerPersonData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('驳回成功')
            this.drawer = false
            this.windowLeftBox = true
            this.approveDialog = false
            this.getBaklogPage()
          }
        })
        .catch(errorHandler('驳回失败'))
    },
    showUpdateRecord(){
      this.getPersonPicUpdateRecordPage()
      this.dialogVisible=true
    }
  },
  watch: {
    windowLeftBox (val) {
      if (!val) {
        this.getPage()
      }
    }
  }
}
</script>

<style scoped>

.page-content{
  display: flex;
  justify-content: space-between;
}
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
  .person-management {
    .el-tree-node__content {
      height: 28px;
    }
    .right-slide-enter,
    .right-slide-leave-active {
      transform: translateX(100%);
    }

    .right-slide-leave-active,
    .right-slide-enter-active {
      transition: all 0.3s;
    }
    .window-left-box {
      position: fixed;
      right: 0;
      top: 0;
      bottom: 0;
      width: 60%;
      z-index: 10;
    }
    .window-left-box .move-enter-active, .window-left-box .move-leave-active {
      transition: all 2s linear;
      transform: translate3d(0, 0, 0);
    }
    .window-left-box .move-enter, .window-left-box .move-leave {
      transform: translate3d(100%, 0, 0);
    }
    .window-left-main {
      width: 100%;
      height: 100%;
      z-index: 30;
      background: #FFFFFF;
      padding: 5px 10px;
      overflow: auto;
    }

    .mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      opacity: .4;
      z-index: -1;
      background-color: #000000;
      transition: opacity .5s ease;
    }


    form {
      width: 450px;
      margin: 0 auto;
      text-align: left;
    }
    .form-line {
      margin: 25px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .line-text{
      color: #48576a;
      font-size: 14px;
      margin-right: 10px;
      width: 100px;
      display: flex;
      justify-content: space-between;
    }
    .line-info {
      width: 220px;
    }
    .form-btn-box {
      width: 530px;
      padding: 0 124px;
      margin: 40px auto 0;
      display: flex;
      justify-content: space-between;
    }

    .person-management-drawer {
      .el-icon-back {
        margin: 20px 20px 10px;
        display: block;
        border: 0;
        font-size: 20px;
        background-color: #ffffff;
        cursor: pointer;
      }
      .el-icon-back:hover {
        color: #00a0e6;
      }
      .all-table-class .el-table td {
        padding: 10px 0;
      }
      form {
        position: relative;
        .drawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
        }
        .noDrawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
          height: 150px;
          line-height: 160px;
          border: 1px dashed #dcdfe6;
          text-align: center;
          color: #999999;
        }
      }
    }
    .drawerBtnBox {
       width: 360px;
       padding-right: 60px;
       margin: 0 auto;
      .btn-confirm {
        border: 0;
        color: #FFF;
        padding: 8px 16px;
        background-color: #00a0e6;
        border-radius: 4px;
        margin-right: 60px;
      }
      .btn-confirm:hover {
        color: #FFF;
        background-color: #06b3ff;
      }
      .reject-button {
        border: 0;
        background-color: #f25721;
        color: #FFFFFF;
        border-radius: 4px;
      }
      .reject-button:hover {
        background-color: #F96E3D;
      }
    }

    .approveDialogBox {
      text-align: left;
      .el-dialog {
        width: 800px;
      }
      .approveMainBox {
        text-align: center;
      }
      .approve_title {
        width: 120px;
      }
      .approveFlexBox {
        width: 500px;
        margin: 0 auto 20px;
        display: flex;
        justify-content: flex-start;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/PersonManagement/PersonManagement.vue